import TemplateApi from "../api/TemplateApi";
import * as types from "../constants/actionConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import * as questionTypes from "../constants/questionTypeConstants";
import * as TEMPLATE from "../constants/templateConstants";
import {createEditorInstanceId, EDITOR_TYPES} from "../utilities/editorInstanceOwnership";


export function initializeQuestionEditor(template, depth = 0) {
    let editableTemplate;
    let answerOptions = [];

    if (template) {
        editableTemplate = {
            templateKey: template.templateKey || "",
            name: template.name || "",
            nameQualifier: (template.nameQualifier)? template.nameQualifier : null,
            description: template.description || "",
            questionType: template.questionType || questionTypes.RADIO,
            optional: template.optional ?? true,
            preserveAnswer: template.preserveAnswer || true,
            metadata: template.metadata || {},
            searchTags: template.searchTags || [],
            showGroupKeys: template.showGroupKeys || [],
            id: template.id
        };
        answerOptions = (template.answerOptionTemplates)? template.answerOptionTemplates.filter((element) => {
            return element !== null;
        }) : [];
    }
    else {
        editableTemplate = {
            templateKey: "",
            name: "",
            nameQualifier: null,
            description: "",
            questionType: questionTypes.RADIO,
            optional: true, // Default new question to optional.
            preserveAnswer: true,
            answerOptionTemplates: [],
            searchTags: [],
            metadata: {},
            showGroupKeys: []
        };
    }

    return {
        type: types.QUESTION_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.QUESTION, depth),
            template: editableTemplate,
            answerOptionTemplates: answerOptions,
            options: {
                createMode: (template)? !template.templateKey : true,
                isEdit: true,
                hasDescription: (template) ? !!template.description : true,
                validate: [],
                isValidating: false,
                hasVersion: null,
                hasReference: null
            }
        },
        depth
    };
}

export function updateQuestionTemplate(template, depth = 0) {
    return (dispatch) => {
        dispatch({type: types.QUESTION_EDITOR_UPDATE_TEMPLATE, payload: {template}, depth: depth});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Questions show group keys
// ---------------------------------------------------------------------------------------------------------------------

export function addQuestionShowGroupKeys(template, showGroupKeys = [], depth = 0) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.QUESTION_EDITOR_ADD_SHOW_GROUP_KEYS, payload: {template}, showGroupKeys: showGroupKeys, depth: depth});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function setQuestionEditorShowGroupKeys(template, showGroupKeys = [], depth = 0) {
    //debugger; // SSSSS Show Group Testing
    return (dispatch) => {
        dispatch({type: types.QUESTION_EDITOR_SET_SHOW_GROUP_KEYS, payload: {template}, showGroupKeys: showGroupKeys, depth: depth});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// -
// ---------------------------------------------------------------------------------------------------------------------

export function clearQuestionEditor(depth = 0) {
    return (dispatch) => {
        dispatch({type: types.QUESTION_EDITOR_CLEAR, depth: depth});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function clearQuestionTemplateSearchTags(depth = 0) {
    return (dispatch) => {
        dispatch({type: types.QUESTION_EDITOR_CLEAR_SEARCH_TAGS_ARRAY, depth: depth});
    };
}

export function updateQuestionEditorSettings(options, depth = 0) {
    return {
        type: types.QUESTION_EDITOR_UPDATE_EDITOR,
        options,
        depth
    };
}

export function validateQuestionNameAndQualifierUnique(name, qualifier, depth = 0) {
    return (dispatch) => {
        dispatch({type: types.QUESTION_EDITOR_NAME_AND_QUALIFIER_VALIDATING, depth: depth});
        dispatch(validateQuestionNameAndQualifierExists(name, qualifier, depth))
    };
}

export function validateQuestionNameAndQualifierExists(name, qualifier, depth) {

    let nameQualifier = qualifier === null ? "" : qualifier;

    let thunk = (dispatch) => {
        TemplateApi.checkTemplateNameAndQualifierExists(TEMPLATE.TYPE.QUESTION, name, nameQualifier).then((data) => {
            dispatch({type: types.QUESTION_EDITOR_NAME_AND_QUALIFIER_EXISTS, list: data.collection, depth: depth});
        });
    };

    thunk.meta = {
        debounce: {
            time: 1000,
            key: "__questionExistsCheck",
            leading: false,
            trailing: true
        }
    };

    return thunk;
}

export function checkQuestionReference(id, depth = 0) {
    return (dispatch)=>{
        TemplateApi.getTemplateReferences(TEMPLATE.TYPE.QUESTION, id)
            .then((data) =>{
                dispatch({type: types.QUESTION_EDITOR_CHECK_REFERENCE, data, depth});
            });
    };
}

export function checkQuestionVersion(name, depth = 0) {
    return (dispatch)=>{
        TemplateApi.checkQuestionExists({name})
            .then((data) =>{
                dispatch({type: types.QUESTION_EDITOR_CHECK_VERSION, data, depth});
            });
    };
}

